import { useMemo } from 'react';
import { useInstance } from '../contexts/InstanceContext';
import { moduleCatalog } from '../../modules';
import { coreModule } from './coreModule';
import type { FrontendModule } from './types';

/**
 * Frontend modules active in this instance: the core plus every module of the
 * catalog listed in the instance's `modules` (GET /api/instance).
 */
export function getActiveModules(activeIds: string[]): FrontendModule[] {
  const ids = new Set(activeIds);
  return [coreModule, ...moduleCatalog.filter(m => ids.has(m.id))];
}

export function useActiveModules(): FrontendModule[] {
  const { modules } = useInstance();
  return useMemo(() => getActiveModules(modules), [modules]);
}
